/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  SIGNUP_PARTNER_FAILURE,
  SIGNUP_PARTNER_SUCCESS,
  GET_PARTNER_SUCCESS,
  GET_PARTNER_FAILURE,
  UPDATE_PARTNER_FAILURE,
  UPDATE_PARTNER_SUCCESS,
  LIST_PARTNERS_SUCCESS,
  LIST_PARTNERS_FAILURE,
  SUBMIT_TESTIMONIAL,
  SUBMIT_TESTIMONIAL_SUCCESS,
  SUBMIT_TESTIMONIAL_FAILURE,
  GRANT_PERMISSION,
  GRANT_PERMISSION_SUCEESS,
  GRANT_PERMISSION_FAILURE
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  partner: null,
  testimonial: {
    data: null,
    state: "INIT",
    error: null
  },
  permission: {
    data: null,
    state: "INIT",
    error: null
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SIGNUP_PARTNER_SUCCESS:
      return {
        ...state.partner,
        signUpPartnerSuccess: true,
        partner: action.payload.partner
      };

    case SIGNUP_PARTNER_FAILURE:
      return {
        ...state.partner,
        signUpPartnerSuccess: true,
        message: action.err.message
      };

    case GET_PARTNER_SUCCESS:
      return {
        ...state.partner,
        getPartnerSuccess: true,
        partnerInfo: action.payload.partner
      };

    case GET_PARTNER_FAILURE:
      return {
        ...state.partner,
        getPartnerSuccess: true,
        partnerInfo: null,
        message: action.err.message
      };

    case UPDATE_PARTNER_SUCCESS:
      return {
        ...state.partner,
        updatePartnerSuccess: true,
        updatedPartner: action.payload.partner
      };

    case UPDATE_PARTNER_FAILURE:
      return {
        ...state.partner,
        updatePartnerSuccess: false,
        message: action.err.message
      };

    case LIST_PARTNERS_SUCCESS:
      return {
        ...state.partner,
        listPartnersSuccess: true,
        partners: action.payload.partners
      };

    case LIST_PARTNERS_FAILURE:
      return {
        ...state.partner,
        listPartnersSuccess: true,
        partners: null,
        message: action.err.message
      };

    case SUBMIT_TESTIMONIAL:
      return setLoadingState(state, "testimonial");

    case SUBMIT_TESTIMONIAL_SUCCESS:
      return setSuccessResponse(state, action, "testimonial");

    case SUBMIT_TESTIMONIAL_FAILURE:
      return setErrorResponse(state, action, "testimonial");

    case GRANT_PERMISSION:
      return setLoadingState(state, "permission");
    case GRANT_PERMISSION_SUCEESS:
      return setSuccessResponse(state, action, "permission");
    case GRANT_PERMISSION_FAILURE:
      return setErrorResponse(state, action, "permission");

    default:
      return state;
  }
}
